import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { ResponseListingDto, ResponseSaveDto, RequestUpdatePostDto } from '../dto/documentcontrol.dto';

@Injectable()
export class DocumentControlSf6Api {

  private readonly service: string = '';
  private readonly model: string = 'sf6s';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public docType(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'documentControl/docType';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public save(payload: any): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'documentControl/save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public listing(empId: string): Observable<ResponseListingDto> {
    const method: string = 'GET';
    const func: string = 'documentControl/listing';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseListingDto>(method, url, func, params, body);
  }

  public detail(empId: string, empfamilyId: string, status: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'documentControl/detail';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof empfamilyId !== 'undefined' && empfamilyId !== null) urlParams.empfamilyId = empfamilyId;
    if (typeof status !== 'undefined' && status !== null) urlParams.status = status;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public updatePost(payload: RequestUpdatePostDto): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = "documentControl/updatePost";
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/documentcontrol.api.ts